export default "__VITE_ASSET__CLYA03Wg__"